import React from 'react';
import { motion } from 'framer-motion';
export function HeroBanner() {
  return <section className="relative w-full h-[600px] bg-hero-pattern bg-cover bg-center bg-no-repeat overflow-hidden" data-id="element-106">
      {/* Dark Overlay Gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-charcoal/90 via-charcoal/50 to-transparent" data-id="element-107" />

      {/* Metallic Accent Line */}
      <div className="absolute bottom-0 left-0 w-full h-2 bg-gradient-to-r from-primary via-accent to-primary" data-id="element-108"></div>

      {/* Content Container */}
      <div className="relative h-full max-w-[1400px] mx-auto px-4 lg:px-8 flex flex-col justify-center" data-id="element-109">
        <div className="max-w-3xl pt-10" data-id="element-110">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col" data-id="element-111">
            <div className="inline-block mb-4" data-id="element-112">
              <span className="bg-primary text-white px-4 py-1 font-heading font-bold italic uppercase tracking-wider text-sm skew-x-[-10deg] inline-block" data-id="element-113">
                <span className="block skew-x-[10deg]" data-id="element-114">
                  Premium Manufacturing
                </span>
              </span>
            </div>

            <h1 className="text-6xl md:text-8xl font-heading font-bold text-white uppercase italic leading-[0.85] tracking-tighter mb-6 drop-shadow-xl" data-id="element-115">
              <span className="text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-300" data-id="element-116">
                Precision
              </span>{' '}
              <br data-id="element-117" />
              <span className="text-primary" data-id="element-118">Performance</span>
            </h1>

            <p className="text-gray-200 text-lg md:text-xl font-sans font-medium mb-8 max-w-xl border-l-4 border-primary pl-6 py-2 bg-black/20 backdrop-blur-sm" data-id="element-119">
              Engineered lift kits and suspension components for the modern
              truck enthusiast.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-120">
              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-fit px-10 py-4 bg-primary text-white font-heading font-bold text-xl italic tracking-widest uppercase transition-all hover:bg-white hover:text-primary skew-x-[-10deg]" data-id="element-121">
                <span className="block skew-x-[10deg]" data-id="element-122">Shop Now</span>
              </motion.button>

              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-fit px-10 py-4 border-2 border-white text-white font-heading font-bold text-xl italic tracking-widest uppercase transition-all hover:bg-white hover:text-charcoal skew-x-[-10deg]" data-id="element-123">
                <span className="block skew-x-[10deg]" data-id="element-124">View Catalog</span>
              </motion.button>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Carousel Dots */}
      <div className="absolute bottom-12 right-8 flex gap-3" data-id="element-125">
        <button className="w-12 h-2 bg-primary skew-x-[-20deg]" aria-label="Slide 1" data-id="element-126" />
        <button className="w-12 h-2 bg-white/30 hover:bg-white transition-colors skew-x-[-20deg]" aria-label="Slide 2" data-id="element-127" />
        <button className="w-12 h-2 bg-white/30 hover:bg-white transition-colors skew-x-[-20deg]" aria-label="Slide 3" data-id="element-128" />
      </div>
    </section>;
}